import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TableColumnDTO  {
    _originalTypeClassName = "zERP.BO.TableColumnDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TableColumnDTO.translate = translateService;
}
this.field = null;
this.header = null;
this.type = null;
this.index = null;
this.TableColumnDTOKey = null;
this._key = this.TableColumnDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
field:any;
header:any;
type:any;
index:any;
private _TableColumnDTOKey:any;
get TableColumnDTOKey(): any {
    return this._TableColumnDTOKey;
  }
set TableColumnDTOKey(value: any) {
    this._TableColumnDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TableColumnDTOKey == null || $this.TableColumnDTOKey == 0;
            }


}